import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LoadingSkeleton } from "@/components/shared/loading-skeleton";
import { PageContainer } from "@/components/shared/page-container";
import { useGetProfile } from "@/lib/api/auth/hooks";
import { postLogout } from "@/lib/api/auth";
import { NoticeBoardWidget, ShortcutsWidget } from "@/widgets/dashboard";

function MainPage() {
  const navigate = useNavigate();
  const { data: user, isError } = useGetProfile();

  useEffect(() => {
    if (user) {
      localStorage.setItem("growing-teacher-user", JSON.stringify(user));
    }
  }, [user]);

  useEffect(() => {
    if (!isError) return;
    (async () => {
      await postLogout();
      localStorage.removeItem("growing-teacher-user");
      navigate({ to: "/auth/login", replace: true });
    })();
  }, [isError, navigate]);

  return (
    <PageContainer variant="full" className="gap-6">
      <LoadingSkeleton isLoading={!user} className="w-full h-9">
        <h1 className="w-full text-left text-xl font-semibold">
          {`${user?.name}님, 안녕하세요 🙋‍♂️`}
        </h1>
      </LoadingSkeleton>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <ShortcutsWidget />
        <NoticeBoardWidget />
      </div>
    </PageContainer>
  );
}

export const Route = createFileRoute("/_content/main")({
  component: MainPage,
});
